module.exports = __webpack_public_path__ + "img/bp.9ab1ebd3.jpg";